import { useCallback } from "react";
import { Breadcrumbs } from "~/components/UI";
import Groups from "./Components/Groups";
import { useTranslation } from "react-i18next";

/**
 * @namespace Groups
 */

const GroupsPage = () => {
  const { t } = useTranslation();

  const getBreadcrumbs = useCallback(() => {
    return [{ label: t("title.catalogs") }, { label: t("title.groups") }];
  }, [t]);

  return (
    <>
      <Breadcrumbs links={getBreadcrumbs()} />
      <Groups />
    </>
  );
};

export default GroupsPage;
